import React, { useState } from 'react';
import config from '../../../shared/services/config';
import { EMPTY_ARRAY, EMPTY_STRING, NOOP } from '../../../shared/utils/common';

export const DataContext = React.createContext();

export const DataProvider = ({ data, children }) => {
  return <DataContext.Provider value={{ value }}>
    {children}
  </DataContext.Provider>
}

export const Table = ({ data = EMPTY_ARRAY, headers = EMPTY_ARRAY }) => {
  const UI = config.get('uiv2', {})

  return (
    <div className='tw-preflight'>
      {/* <UI.TableLoader /> */}
      <UI.Grid>
        <UI.GridItem>
          <MerchantDetailCard mid='1222' businessName={'Jimmy'} aclRoleName={'Dancer'} />
        </UI.GridItem>
        <UI.GridItem colSpan={2}>
          <OutletAccordion title='SouledStore' >
            <UI.Grid cols={2} gap={8}>
              <TextCard text='Domlur' />
              <TextCard text='Coorg' />
              <TextCard text='Manali' />
            </UI.Grid>
          </OutletAccordion>
        </UI.GridItem>
        <MOuletCard />
      </UI.Grid>
      <div className='tw-flex tw-flex-col tw-gap-16'>
        <div>
          <DetailsCard mid='1222' businessName={'Bad kid'} aclRoleName={'Fisher'} />
          <TableHeader headers={[
            { label: 'Business Name' },
            { label: 'MID', isSortable: true },
            { label: 'Role' },
          ]} />
          <TableBody data={[['Good Luck!', 12324, 'Killer'], ['Bad Luck!', 12324, 'Killer']]} />
          <UI.Pagination
            totalRows={11}
            currentPage={1}
            rowsPerPage={1}
          />
        </div>
      </div>
    </div>
  )
}

export const percentageFromBasis = (arr = EMPTY_ARRAY) => {
  let sum = 0;
  arr.forEach(v => (sum += v))
  return arr.map(v => (v / sum) * 100)
}


export const TableHeader = ({ headers = EMPTY_ARRAY, colRatios = EMPTY_ARRAY, onOrderChange = NOOP, orderCol, order }) => {
  const UI = config.get('uiv2', {})
  const percentageOfEachCol = percentageFromBasis(colRatios)
  return <div>
    {headers.map(({ label, isSortable }, i) => {
      let iconProps = {
        type: 'up-down-arrow',
        size: '12px'
      }
      if (orderCol == i) {
        if (order == 'asc') {
          iconProps.type = 'asc-arrow'
        } else if (order == 'desc') {
          iconProps.type = 'desc-arrow'
        }
      }
      return <div className={`tw-px-16 tw-py-8 tw-text-gray-300 tw-inline-block`} style={{ width: `${percentageOfEachCol[i]}%` }}>
        <UI.Typography variant='P2' className='tw-flex tw-items-center tw-gap-8'>
          <span>{label}</span>
          {isSortable && <div className='tw-p-4 tw-cursor-pointer' onClick={() => onOrderChange(i)}>
            <UI.PayuIcon {...iconProps} />
          </div>}
        </UI.Typography>
      </div>
    })}
  </div>
}

export const TableBody = ({ data = EMPTY_ARRAY, colRatios = EMPTY_ARRAY, onRowClick = NOOP }) => {
  const UI = config.get('uiv2', {})
  const percentageOfEachCol = percentageFromBasis(colRatios)
  return (
    <div>
      {data.map(col => <div className='tw-cursor-pointer tw-border-1 tw-rounded-16 tw-border-gray-40 tw-mb-16 tw-bg-white hover:tw-bg-seablue-50 hover:tw-border-green-100' onClick={() => onRowClick(col)}>
        {col.map((v, i) => (<div className='tw-p-16 tw-text-gray-800 tw-inline-block' style={{ width: `${percentageOfEachCol[i]}%` }}>
          <UI.Typography variant='P2' className='tw-flex tw-items-center tw-gap-8' weight='semi-bold'>
            <span>{v}</span>
          </UI.Typography>
        </div>))}
      </div>)}
    </div>

  )
}


export const DetailsCard = ({ mid, businessName, aclRoleName, onClick = NOOP, className = EMPTY_STRING }) => {
  const UI = config.get('uiv2', {})

  return (
    <div
      className='tw-flex tw-flex-col tw-justify-between tw-gap-24 tw-p-16 tw-border-1 tw-rounded-8 tw-border-gray-40 tw-bg-white tw-cursor-pointer tw-w-200'
      onClick={onClick}
    >
      <div className='tw-flex tw-flex-col tw-gap-8'>
        <UI.Typography variant='P2'>
          {mid}
        </UI.Typography>
        <UI.Typography variant='SH2'>
          {businessName}
        </UI.Typography>
      </div>
      <div>
        <UI.Chip value={aclRoleName} color='BLUE' />
      </div>
    </div>
  )
}


export const TableLoader = () => {
  const UI = config.get('uiv2', {})

  return <div className='tw-flex tw-flex-col tw-py-24'>
    <div className='tw-mb-24'>
      <div className='tw-text-gray-800 tw-inline-block tw-px-8' style={{ width: '30%' }}>
        <UI.Skeleton />
      </div>
      <div className='tw-text-gray-800 tw-inline-block tw-px-8' style={{ width: '20%' }}>
        <UI.Skeleton />
      </div>
      <div className='tw-text-gray-800 tw-inline-block tw-px-8' style={{ width: '50%' }}>
        <UI.Skeleton />
      </div>
    </div>
    <div className='tw-mb-24'>
      <div className='tw-text-gray-800 tw-inline-block tw-px-8' style={{ width: '30%' }}>
        <UI.Skeleton />
      </div>
      <div className='tw-text-gray-800 tw-inline-block tw-px-8' style={{ width: '20%' }}>
        <UI.Skeleton />
      </div>
      <div className='tw-text-gray-800 tw-inline-block tw-px-8' style={{ width: '50%' }}>
        <UI.Skeleton />
      </div>
    </div>
    <div className='tw-mb-24'>
      <div className='tw-text-gray-800 tw-inline-block tw-px-8' style={{ width: '30%' }}>
        <UI.Skeleton />
      </div>
      <div className='tw-text-gray-800 tw-inline-block tw-px-8' style={{ width: '20%' }}>
        <UI.Skeleton />
      </div>
      <div className='tw-text-gray-800 tw-inline-block tw-px-8' style={{ width: '50%' }}>
        <UI.Skeleton />
      </div>
    </div>
  </div>
}

export const Error = ({
  actions = EMPTY_ARRAY,
  heading = EMPTY_STRING,
  description = EMPTY_STRING,
  message = EMPTY_STRING,
  infographicType = 'filter-search'
}) => {
  const UI = config.get('uiv2', {});

  return <div className='tw-flex tw-justify-center'>
    <UI.Error
      actions={actions}
      description={{
        props: {
          className: 'tw-text-green-gray-300',
          variant: 'P2',
          weight: 'medium'
        },
        text: description
      }}
      heading={{
        props: {
          className: 'tw-text-gray-900',
          variant: 'H3',
          weight: 'semi-bold'
        },
        text: heading
      }}
      imageProps={{
        className: 'tw-p-16',
        height: '152px',
        type: infographicType,
        width: '152px'
      }}
      message={{
        props: {
          className: 'tw-text-green-gray-300',
          variant: 'SH3',
          weight: 'medium'
        },
        text: message,
      }}
    />
  </div>
}